import { CLEVERTAP_KEYS } from "@payment-client/constants/Clevertap";
import { CART_PAGE, PLAN_PURCHASE_PAGE } from "@payment-client/constants/TextDict";
import { getBridgeSdk, GlobalHeaderState, SwgyHeaderKeysList } from "@swiggy-private/checkout-core";
import { isEmpty } from "@swiggy-private/core-ui";
import { OrderData } from "@swiggy-private/payment-types";

export const logSwiggyOnePurchaseEvent = (orderData: OrderData): void => {
    if (!isEmpty(orderData.orderSubscriptions)) {
        const params = {
            planId: orderData.orderSubscriptions[0].planId,
            city: GlobalHeaderState.getHeader(SwgyHeaderKeysList.cityid) || "NULL",
            source: isEmpty(orderData.orderItems) ? PLAN_PURCHASE_PAGE : CART_PAGE,
        };
        getBridgeSdk().logClevertapEvent({
            eventName: CLEVERTAP_KEYS.ONE_PLAN_PURCHASED,
            params,
        });
    }
};
